<script setup lang="ts">
import { useLocalization } from '@/i18n';
import { useRouter } from 'vue-router';

defineProps({ slotName: String, alignment: String, hideOnMobile: Boolean, hideOnDesktop: Boolean });
const { i18n } = useLocalization();
const { currentRoute } = useRouter();
</script>
<template>
  <scale-telekom-nav-list
    variant="lang-switcher"
    :slot="slotName"
    :alignment="alignment"
    :aria-label="$t('languageSwitcher.label')"
    ><router-link
      v-for="lang of i18n.global.availableLocales"
      :key="lang"
      :to="{ params: { lang }, query: currentRoute.query }"
      custom
      v-slot="{ isActive, href, navigate }"
    >
      <scale-telekom-nav-item
        :hide-on-mobile="hideOnMobile"
        :hide-on-desktop="hideOnDesktop"
        :active="isActive"
        :aria-label="$t('languageSwitcher.' + lang + '.switchTo')"
      >
        <a
          :href="href"
          :title="$t('languageSwitcher.' + lang + '.ariaLabel')"
          :aria-current="i18n.global.locale.value === lang"
          @click="navigate"
          >{{ $t('languageSwitcher.' + lang + '.linkName') }}</a
        >
      </scale-telekom-nav-item></router-link
    >
  </scale-telekom-nav-list>
</template>
